import classNames from 'classnames';
import {orderBy} from 'lodash';
import React from 'react';
import {connect} from 'react-redux';
import swal from 'sweetalert2';
import {getHeaders, getMPPEndpoint} from '../../../../helpers/endpoint';

const CURRENT_INTERNATIONAL_CHAMPIONSHIP_ID = 8; // 8 = CDM

export const getMPPSelections = (championshipId, onSuccess, onError) => {
  return (_dispatch, getState) => {
    fetch(getMPPEndpoint('getMPPSelections', championshipId), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) {
          onError(data.error);
        } else {
          onSuccess(data);
        }
      })
      .catch(error => {
        onError && onError(error);
      });
  };
};

export const patchMPPSelection = (payload, onSuccess, onError) => {
  return (_dispatch, getState) => {
    fetch(
      getMPPEndpoint('patchMPPSelection', {
        championshipId: payload.championshipId,
        clubId: payload.clubId,
        outOfCompetition: payload.outOfCompetition,
      }),
      {
        method: 'PATCH',
        headers: getHeaders(getState().authentication),
      },
    )
      .then(response => response.json())
      .then(data => {
        if (data.error) {
          onError(data.error);
        } else {
          onSuccess(data);
        }
      })
      .catch(error => {
        onError && onError(error);
      });
  };
};

class MPPSelections extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selections: null,
    };
  }

  getSelections = () => {
    this.props.dispatch(
      getMPPSelections(
        CURRENT_INTERNATIONAL_CHAMPIONSHIP_ID,
        ({selections}) => {
          this.setState({
            selections: orderBy(selections, ['quotation'], ['desc']),
          });
        },
      ),
    );
  };

  componentDidMount() {
    this.getSelections();
  }

  render() {
    const {selections} = this.state;

    return (
      <div className="box">
        <div className="box-header with-border">
          <h3 className="box-title pull-left">
            <i className="fa fa-user-circle-o" /> Selections Live
          </h3>
        </div>
        <div className="box-body">
          <table className="table text-center table-striped">
            <thead>
              <tr>
                <th>Selection</th>
                <th>Active</th>
              </tr>
            </thead>
            <tbody>
              {selections &&
                selections.map(
                  selection =>
                    Boolean(selection.quotation) && (
                      <tr>
                        <td>
                          <b>{selection.country}</b>
                          {` - ${selection.quotation} pts`}
                        </td>
                        <td>
                          <i
                            onClick={() => {
                              swal({
                                title: 'Are you sure ?',
                                type: 'info',
                                showCloseButton: true,
                                showCancelButton: true,
                                focusConfirm: false,
                                confirmButtonText: 'Yes',
                                cancelButtonText: 'No',
                              })
                                .then(() => {
                                  this.props.dispatch(
                                    patchMPPSelection(
                                      {
                                        championshipId:
                                          CURRENT_INTERNATIONAL_CHAMPIONSHIP_ID,
                                        clubId: selection.id,
                                        outOfCompetition:
                                          !selection.outOfCompetition,
                                      },
                                      () => this.getSelections(),
                                    ),
                                  );
                                })
                                .catch(error => {
                                  console.log(error);
                                });
                            }}
                            className={classNames('fa fa-2x', {
                              'fa-toggle-on': !selection.outOfCompetition,
                              'fa-toggle-off': selection.outOfCompetition,
                            })}
                          />
                        </td>
                      </tr>
                    ),
                )}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

export default connect()(MPPSelections);



// WEBPACK FOOTER //
// ./src/pages/Other/MPP/MPPSelections/index.js